import { DaperClient } from "@data/daper-client";

import { wrapResponse } from "./wrapResponse";

async function getSecuritiesHandler(req, res) {
  // eslint-disable-next-line no-param-reassign
  res = wrapResponse(res);

  const params = req.query as {
    securities: string[];
  };

  const daperClient = DaperClient.init({
    host: process.env.DAPER_URL,
    username: process.env.DAPER_MARKETS_USERNAME,
    password: process.env.DAPER_MARKETS_PASSWORD,
  });

  const daperResponse = await daperClient.getFinanceReferenceSecurities(params);

  return res.status(200).json(daperResponse);
}

export default getSecuritiesHandler;
